import React from "react";

interface IQuoteCard {
  backgroundGradient: string;
  intersect: React.ReactNode;
  image?: string;
  quote?: string | undefined;
  author?: string;
  hasImage?: boolean;
  imageWidth?: string;
  quoteWidth?: string;
  topLeftSVG?: React.ReactNode;
  bottomRightSVG?: React.ReactNode;
  className?: string;
  classNameContent?: string;
}

const QuoteCard = ({
  backgroundGradient,
  intersect,
  image,
  quote,
  author,
  imageWidth,
  quoteWidth,
  topLeftSVG,
  bottomRightSVG,
  hasImage,
  className,
  classNameContent = 'py-16 px-5 md:px-6 md:py-5',
}: IQuoteCard) => {
  return (
    <div className={`relative ${className}`}>
      {topLeftSVG && (
        <div className="absolute -top-[29px] left-[22px] md:left-[45px] z-10 ">
          {topLeftSVG}
        </div>
      )}

      {bottomRightSVG && (
        <div className="absolute -bottom-[29px] right-[22px] md:right-[45px] z-10">
          {bottomRightSVG}
        </div>
      )}
      <div
        className={`relative ${backgroundGradient} overflow-hidden rounded-3xl justify-center items-center`}
      >
        <div className="absolute inset-0 z-0">
          <div className="bottom-0 w-full h-full overflow-hidden">
            {intersect}
          </div>
        </div>
        <div className={`relative z-10 flex flex-col items-center justify-center lg:flex-row md:justify-center h-full ${classNameContent}`}>
          {hasImage && (
            <div className={`qc-image pb-[31px] lg:pb-0 lg:w-${imageWidth}`}>
              <img
                src={image}
                alt="Person"
                className={`lg:w-[287px] md:mr-[3rem] mx-auto`}
                loading="lazy"
              />
            </div>
          )}
          <div
            className={`flex justify-center items-center lg:w-${quoteWidth}`}
          >
            <div className="w-full text-white">
              <p className="subtitle">{quote}</p>
              {author && <p className="mt-2 subtitle-2-bold w-full md:w-8/12">{author}</p>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteCard;
